import React from 'react';
import Header2 from './../Common/Header2';
import Footer from './../Common/Footer';
import Slider1 from './../Elements/Slider1';
import About2 from './../Elements/About2';
import WhatWeDo1 from './../Elements/WhatWeDo1';
import Testimonials1 from './../Elements/Testimonials1';
import ProjectsList from '../Elements/ProjectsList';
//import GreetingsMarquee from '../GreetingsMarquee';


class Home1 extends React.Component {
    render() {
        return (
            <>
                <Header2 />
                <div className="page-content">
                    {/* <GreetingsMarquee className="" /> */}
                    <Slider1 />
                    <About2 />
                    <WhatWeDo1 />
                    <ProjectsList />
                    <Testimonials1 />
                </div>
                <Footer />
            </>
        );
    };
};

export default Home1;